const MonthArr = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"];

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    if(document.getElementById('cart-bundle-input')) {
      document.getElementById('cart-bundle-input').addEventListener('change', function(e) {
        if (this.checked) {
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              quantity: 1,
              id: document.getElementById('cart-bundle-input').getAttribute('data-variant-id')
            })
          })
          .then(response => {
            window.location.href="/cart";
          })
          .catch((error) => {
            console.error('error:', error);
          });
        }
      });
    }
  }

  cartUpdateUnsubscriber = undefined;

  calcMonday(date, week_num) {
    date.setDate(date.getDate() + week_num*7 - date.getDay()+1);
    return date;
  }
  calcFriday(date, week_num) {
    date.setDate(date.getDate() + week_num*7 - date.getDay()+5);
    return date;
  }
/* CHATGPT NEW FUNCTION PRS */
getDateStr(week_num) {
  // Ensure the input week number is a non-negative integer
  week_num = Math.max(0, Math.floor(week_num));

  // Initialize the current date and set time to midnight for accurate comparison
  var currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0); // Set time to midnight
  currentDate.setDate(currentDate.getDate() - 7); //set current date to a week ago so we can show current week availability
  
  // Calculate the start and end dates of the week
  var startDate = this.calcMonday(new Date('May 22 2023'), week_num);
  var endDate = this.calcFriday(new Date('May 26 2023'), week_num);

  // Ensure startDate is not in the past
  while (startDate <= currentDate) {
    week_num += 1;
    startDate = this.calcMonday(new Date('May 22 2023'), week_num);
    endDate = this.calcFriday(new Date('May 26 2023'), week_num);
  }

  // Initialize variables for building the date range string
  var curDate = new Date();
  var weekStr = '';

  // If the start date's year is not the current year, add the year to weekStr
  //if (startDate.getUTCFullYear() != curDate.getUTCFullYear()) {
  //  weekStr += startDate.getUTCFullYear() + ' ';
  //}

  // Get the month numbers of the start and end dates
  let startMonth = startDate.getUTCMonth();
  let endMonth = endDate.getUTCMonth();

  // Add the start date's month and day to weekStr
  weekStr += MonthArr[startMonth] + ' ' + startDate.getUTCDate() + ' - ';

  // If the start and end dates are in different months, add the end date's month to weekStr
  if (startMonth != endMonth) {
    weekStr += MonthArr[endMonth] + ' ';
  }

  // Add the end date's day to weekStr
  weekStr += endDate.getUTCDate();
  console.log("Output of weekStr:", weekStr);
  // Return the formatted date range string
  return weekStr;
}

  /* OLD FUNCTION 
getDateStr(week_num) {
    var startDate = this.calcMonday(new Date('May 22 2023'), week_num)
    var endDate = this.calcFriday(new Date('May 26 2023'), week_num)
    var curDate = new Date();
    var weekStr = '';
//    if(startDate.getUTCFullYear() != curDate.getUTCFullYear()) {
//      weekStr += startDate.getUTCFullYear() + ' ';
//    }
    let startMonth = startDate.getUTCMonth();
    let endMonth = endDate.getUTCMonth();
    weekStr += MonthArr[startMonth] + ' ' + startDate.getDate() + ' - ';
    if(startMonth != endMonth) {
      weekStr += MonthArr[endMonth] + ' ';
    }
    weekStr += endDate.getDate();

    return weekStr;
  }*/

  
  updateShippingInfo() {
    var total_product_count = 0;
    var all_items = document.querySelectorAll('cart-items .cart-items tbody .cart-item').length>0 ? document.querySelectorAll('cart-items .cart-items tbody .cart-item') : document.querySelectorAll('cart-drawer-items .cart-items tbody .cart-item')
    all_items.forEach((item) => {
      var cur_item_val = parseInt(item.querySelector('input').value);
      if(!cur_item_val) {
        cur_item_val = 0;
        item.querySelector('input').value = 0;
      }
      total_product_count += cur_item_val;
      var rest_items_count = parseInt(item.getAttribute('data-inventory')) - cur_item_val;
      if(rest_items_count > 0) {
        item.setAttribute('data-weeks-after', 0);
      }
      else {
        var add_count = parseInt(item.getAttribute('data-add'));
        if(add_count == 0)
          add_count = 0.001;
        item.setAttribute('data-weeks-after', Math.ceil(rest_items_count*-1/add_count));
      }
    })
    //show available weeks
    var available_weeks_after = 0;

    document.querySelectorAll('.cart-items tbody .cart-item').forEach(item => {
      if(parseInt(item.getAttribute('data-weeks-after')) > available_weeks_after) {
        available_weeks_after = parseInt(item.getAttribute('data-weeks-after'));
      }
    })
    if(document.querySelector('cart-drawer #first-week')) document.querySelector('cart-drawer #first-week').classList.remove('v-hidden');  
    if(document.querySelector('cart-drawer #second-week')) document.querySelector('cart-drawer #second-week').classList.remove('v-hidden');
    if(document.querySelector('cart-drawer #third-week')) document.querySelector('cart-drawer #third-week').classList.remove('v-hidden');
    if(document.querySelector('.cart__footer #first-week')) document.querySelector('.cart__footer #first-week').classList.remove('v-hidden'); 
    if(document.querySelector('.cart__footer #second-week')) document.querySelector('.cart__footer #second-week').classList.remove('v-hidden');
    if(document.querySelector('.cart__footer #third-week')) document.querySelector('.cart__footer #third-week').classList.remove('v-hidden');

    if(document.querySelector('cart-drawer #first-week')) document.querySelector('cart-drawer #first-week').innerHTML = this.getDateStr(available_weeks_after);
    if(document.querySelector('cart-drawer #second-week')) document.querySelector('cart-drawer #second-week').innerHTML = this.getDateStr(available_weeks_after+1);
    if(document.querySelector('cart-drawer #third-week')) document.querySelector('cart-drawer #third-week').innerHTML = this.getDateStr(available_weeks_after+2);
    if(document.querySelector('.cart__footer #first-week')) document.querySelector('.cart__footer #first-week').innerHTML = this.getDateStr(available_weeks_after);
    if(document.querySelector('.cart__footer #second-week')) document.querySelector('.cart__footer #second-week').innerHTML = this.getDateStr(available_weeks_after+1);
    if(document.querySelector('.cart__footer #third-week')) document.querySelector('.cart__footer #third-week').innerHTML = this.getDateStr(available_weeks_after+2);
    if(available_weeks_after == 24) {
      if(document.querySelector('cart-drawer #third-week')) document.querySelector('cart-drawer #third-week').classList.add('v-hidden');
      if(document.querySelector('.cart__footer #third-week')) document.querySelector('.cart__footer #third-week').classList.add('v-hidden');
    }
    if(available_weeks_after == 25) {
      if(document.querySelector('cart-drawer #second-week')) document.querySelector('cart-drawer #second-week').classList.add('v-hidden');
      if(document.querySelector('.cart__footer #second-week')) document.querySelector('.cart__footer #second-week').classList.add('v-hidden');
    }
    if(available_weeks_after == 26) {
      if(document.querySelector('cart-drawer #first-week')) document.querySelector('cart-drawer #first-week').classList.add('v-hidden');
      if(document.querySelector('.cart__footer #first-week')) document.querySelector('.cart__footer #first-week').classList.add('v-hidden');
//      window._klOnsite = window._klOnsite || [];
//     window._klOnsite.push(['openForm', 'T5Lhs5']);
    }

    document.querySelectorAll('.avaiable_weeks .date-item').forEach(item => {
      item.addEventListener('click', function(){
        if(document.querySelector('.avaiable_weeks .date-item.active'))
          document.querySelector('.avaiable_weeks .date-item.active').classList.remove('active');
        item.classList.add("active");
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json' 
          },
          body: JSON.stringify({note: document.querySelector('.avaiable_weeks .date-item.active').textContent})
        })
        .then(response => {
          
        })
      })
    })
  }
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onCartUpdate() {
    fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceQty = html.querySelector('cart-items');
        this.innerHTML = sourceQty.innerHTML;
      })
      .catch(e => {
        console.error(e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        if(this.classList.contains('is-empty') && parsedState.item_count > 0){
          const currentFooter = document.getElementById("TdCartDrawer").querySelector(".drawer__footer");
          currentFooter.innerHTML =
              this.getSectionInnerHTML(parsedState.sections["td-cart-drawer"], ".drawer__footer");
        }
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('.cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {source: 'cart-items'});
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if(errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
    
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if( mainCartItems )    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
      constructor() {
        super();

      this.addEventListener('change', debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, ON_CHANGE_DEBOUNCE_TIMER))
      }
  });
};
